import styled from "styled-components";

export const ControlsContainer = styled("div")`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  margin-left: 14.5rem;
  margin-right: 15rem;
`;
